import './WorkerServiceDetail.less'
import { useSearchParams } from 'react-router-dom'

const WorkerServiceDetail = () => {
  const [ params ] = useSearchParams()
  const prevId = params.getAll('id')[0]

  return (
    <div className='pg-worker-service-detail'>
      <img className='detial-img' src={`https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerService/detail-0${prevId}.png`} />
    </div>
  )
}

export default WorkerServiceDetail